import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';


const routes: Routes = [
  // {
  //   path: '',
  //   component: AppComponent,
  //   children: [
  //     { path: '', redirectTo: 'register', pathMatch: 'full' },
  //     { path: 'register', loadChildren: () => import('./routes/register/register.module').then(m => m.RegisterModule) }
  //   ]
  // }
  { path: '', redirectTo: 'register', pathMatch: 'full' },
  { path: 'register', loadChildren: () => import('./routes/register/register.module').then(m => m.RegisterModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
